//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/popup'

//#endregion

import { ItemSwapperPopupScope, ItemSwapperPopupController } from "./item-swapper-popup.directive.controller"
import { UserSessionService, USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"

//#region Asset Imports

import './item-swapper-popup.scss'
import * as TEMPLATE from './item-swapper-popup.tpl.html'

//#endregion

// #region Consts

export const DIRECTIVE_NAME: string = 'itemSwapperPopup'

// #endregion

// #region Setup

export class ItemSwapperPopupDirective implements ng.IDirective {
    controller = [
        '$scope',
        USER_SESSION_SERVICE_NAME,
        ($scope: ItemSwapperPopupScope<any>, userSession: UserSessionService) => new ItemSwapperPopupController($scope, userSession)
    ]

    restrict = 'E'

    scope = {
        id: '=',
        options: '='
    }

    template = TEMPLATE
}

// #endregion